export default __webpack_public_path__ + "static/facebook-qrcode-28493dc4a8335192fe7dc4e290acf26d.png";